<section class="h-full flex flex-col gap-2 z-0 relative overflow-y-auto  p-2 lg:pl-0">
    <div
        class="max-w-6xl p-4 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg">
        <form [formGroup]="configForm" (ngSubmit)="onSave()">
            <h1 class="heading">
                {{configId ? 'Edit' : 'Add'}}
                 <!-- Add -->
            </h1>
            <hr class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />

            <section class="grid gap-4 md:grid-cols-2">

                <!-- title -->
                <div class="space-y-1">
                    <label class="subheading">
                        Reference <span class="text-red-600">*</span>
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input type="text" formControlName="reference" [readonly]="verification?.reference" /> 
                        </div>
                    </div>
                    <div *ngIf="form.reference.errors && submitted">
                        <div *ngIf="form.reference.errors.required" class="error">
                            <p class="mt-2 text-red-600 text-xs">
                                Reference is required
                            </p>
                        </div>
                    </div>
                </div>
                
                  <div class="space-y-1">
                    <label class="subheading">
                        General Url <span class="text-red-600">*</span>
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input type="text" formControlName="generalUrl" [readonly]="verification?.generalUrl" />
                        </div>
                    </div>
                    <div *ngIf="form.generalUrl.errors && submitted">
                        <div *ngIf="form.generalUrl.errors.required" class="error">
                            <p class="mt-2 text-red-600 text-xs">
                                General Url is required
                            </p>
                        </div>
                    </div>
                </div>

                 <div class="space-y-1">
                    <label class="subheading">
                       Trip Url
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input type="text" formControlName="tripUrl" [readonly]="verification?.tripUrl" />
                        </div>
                    </div>
                </div>

                  <div class="space-y-1">
                    <label class="subheading">
                        Vehicle Url
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input type="text" formControlName="vehicleUrl" [readonly]="verification?.vehicleUrl" />
                        </div>
                    </div>
                </div>

                  <div class="space-y-1">
                    <label class="subheading">
                        Driver Url
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input type="text" formControlName="driverUrl" [readonly]="verification?.driverUrl" />
                        </div>
                    </div>
                </div>
            </section>
            <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            <section class="flex justify-end gap-4">
                <button type="submit" class="btn btn-secondary">
                    {{configId ? 'Update' : 'Create'}}
                     <!-- Save -->
                </button>
            </section>
        </form>
    </div>
</section>